(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var button=root.querySelector('[data-recommendation-add]'), status=root.querySelector('[data-recommendation-status]'), link=root.querySelector('[data-recommendation-cart]');
    var busy=false, completed=false;
    var money=new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:root.dataset.currency});
    function selection() {
      var items=[], total=0;
      root.querySelectorAll('[data-recommendation-card]').forEach(function (card) {
        var include=card.querySelector('[data-recommendation-include]');
        if (include && !include.checked) return;
        var select=card.querySelector('[data-recommendation-variant]');
        var option=select.options[select.selectedIndex];
        if (!option || option.disabled) return;
        items.push({id:Number(option.value),quantity:1});total+=Number(option.dataset.price);
      });
      return {items:items,total:total};
    }
    function update() {
      var order=selection(), total=root.querySelector('[data-recommendation-total]');
      if (total) { total.textContent=money.format(order.total/100); button.textContent='ADD ALL '+order.items.length+' TO CART'; }
      button.disabled=busy || completed || !order.items.length;
    }
    root.addEventListener('change',function () { if (!busy) { completed=false;status.textContent='';update(); } });
    button.addEventListener('click',async function () {
      var order=selection();if (busy || completed || !order.items.length) return;
      busy=true;update();status.textContent='Adding your selection…';link.hidden=true;
      var controls=Array.from(root.querySelectorAll('select,input')).filter(function(e){return !e.disabled;});
      controls.forEach(function(e){e.disabled=true;});
      var route=(window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      try {
        var response=await fetch(route+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:order.items})});
        var data=await response.json();if (!response.ok) throw new Error(data.description || data.message || 'Could not add selection.');
        completed=true;status.textContent=order.items.length+' items added to your cart.';
        if (root.dataset.cartRecommendation === 'true') { window.location.assign(route+'cart'); return; }
      } catch (error) { status.textContent=error.message+' Check your cart before retrying.'; }
      link.hidden=false;
      try {
        var result=await fetch(route+'cart.js',{cache:'no-store'});if (!result.ok) throw new Error('Cart refresh failed');
        var cart=await result.json();
        document.dispatchEvent(new CustomEvent('textual:insurance-cart-updated',{detail:cart}));
        document.dispatchEvent(new CustomEvent('textual:cart-updated',{detail:cart}));
      } catch (_) { status.textContent+=' Open your cart to review the final total.'; }
      finally { controls.forEach(function(e){e.disabled=false;});busy=false;update(); }
    });
    update();
  }
  document.querySelectorAll('[data-recommendation-order]').forEach(init);
  document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-recommendation-order]').forEach(init);});
}());
